import styled from 'react-emotion';
import theme from '@ublend-npm/aulaui-next-web/themes/default';
import { SPACE_SELECTOR_HEIGHT } from '../../../../constants/sizes';

export const ChipsWrapper = styled.div`
  padding: ${theme.spacing.medium} 0;
`;

export const ContentContainer = styled('div')`
  padding: ${theme.spacing.medium} 0 0 0;
  flex: 1;
`;

export const Container = styled('div')`
  padding: 0 0 0 54px;
  height: calc(100% - ${SPACE_SELECTOR_HEIGHT}px);
  display: flex;
  flex-direction: column;
`;
